import { render, staticRenderFns } from "./CheckoutLayout.vue?vue&type=template&id=5f37196b&scoped=true&"
import script from "./CheckoutLayout.vue?vue&type=script&lang=js&"
export * from "./CheckoutLayout.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutLayout.vue?vue&type=style&index=0&id=5f37196b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f37196b",
  null
  
)

export default component.exports